import script from "./StudentTotalReport.vue?vue&type=script&setup=true&lang=ts"
export * from "./StudentTotalReport.vue?vue&type=script&setup=true&lang=ts"

import "./StudentTotalReport.vue?vue&type=style&index=0&id=c0db4688&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0db4688"]])

export default __exports__